
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"bedding-and-linen",attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{staticClass:"bg",attrs:{"stroke":"#414142","stroke-width":"2","fill":"#FFF","d":"M1 1h58v58H1z"}}),_c('g',{staticClass:"bed icon-img",attrs:{"fill":"#3F3F40"}},[_c('path',{staticClass:"icon-img",attrs:{"d":"M52.146 30.801H9.371V14.166h3.802v11.882h-2.376v1.901h41.349v2.852zm0 5.703H9.371v-.95h29.467v-1.901H9.371v-.951h42.775v3.802zm-1.901 6.179h1.901v-4.277h-1.901v4.277zm-40.874 0h1.901v-4.277H9.371v4.277zm5.703-16.635H25.53v-1.9H15.074v1.9zm37.072 0H27.432v-1.9c0-1.05-.851-1.902-1.902-1.902H15.074v-8.08a1.9 1.9 0 00-1.901-1.9H9.371a1.9 1.9 0 00-1.901 1.9v29.468c0 .524.426.95.95.95h3.803a.95.95 0 00.95-.95v-5.229h35.171v5.229c0 .524.425.95.95.95h3.803a.95.95 0 00.95-.95V27.949a1.902 1.902 0 00-1.901-1.901z"}})])])])
          )
        }
      }
    